/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_No_Event_SelectedInputs */



/**
* | output |
* | --- |
* | "No event selected for preview" |
*
* @param {Video_Export_Preview_No_Event_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_no_event_selected = /** @type {((inputs?: Video_Export_Preview_No_Event_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_No_Event_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun evenement selectionne pour la previsualisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Für die Vorschau wurde kein Ereignis ausgewählt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun evento selezionato per l'anteprima")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для предварительного просмотра не выбрано ни одного события.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ningún evento seleccionado para la vista previa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择任何事件进行预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレビューにイベントが選択されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्वावलोकन के लिए कोई इवेंट चयनित नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum evento selecionado para pré-visualização.")
	return /** @type {LocalizedString} */ ("No event selected for preview")
});